import * as React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

export interface DataGridCellProps {
  children: React.ReactNode;
  className?: string;
}

const useStyles = makeStyles({
  root: {
    height: '100%',
    padding: '0 4px',
    '& > div': {
      // height: 50,
      minHeight: 50,
      display: 'flex',
      alignItems: 'center'
    }
  }
});

const DataGridCell = ({ children, className }: DataGridCellProps) => {
  const classes = useStyles();
  return <div className={clsx(classes.root, className)}>{children}</div>;
};

export default DataGridCell;
